<template>
  <Row>
    <i-table size="small" :data="dataset" :columns="columns"></i-table>
    <br />
    <i-button
      v-if="$can('manage', 'contextual_analysis')"
      @click="$router.push(`/countries/contextual_analysis/new/${iso3}`)"
    >
      New Contextual Analysis
    </i-button>
  </Row>
</template>

<script>
import axios from "axios";

export default {
  props: ["iso3", "conditions"],
  data() {
    return {
      dataset: [],
      columns: [
        {
          type: "expand",
          width: 50,
          render: (h, params) => {
            return h("div", params.row.content);
          },
        },
        {
          title: "Title",
          key: "title",
          sortable: true,
          render: (h, params) =>
            h("div", [
              h(
                "router-link",
                {
                  attrs: {
                    to: "/countries/contextual_analysis/" + params.row.id,
                  },
                },
                [h("span", params.row.title)]
              ),
            ]),
        },
        {
          title: "Publication Date",
          key: "publication_date",
          sortable: true,
        },
        {
          title: "Displacement Type",
          key: "displacement_type",
        },
        {
          title: "Group",
          key: "group",
        },
      ],
    };
  },

  created() {
    this.load();
  },

  watch: {
    iso3() {
      this.load();
    },
  },

  methods: {
    // load the records into the data
    load() {
      this.$Loading.start();
      axios
        .get("/psql/contextual_analysis", {
          params: {
            iso3: `eq.${this.iso3}`,
          },
        })
        .then(response => {
          this.dataset = response.data;
          console.log("Contextual analysis has been loaded successfully");
          this.$Loading.finish();
        })
        .catch(error => {
          this.$Loading.error();
          console.error(error.response);
          this.$Notice.error({
            title: "Error",
            desc: "Contextual analysis failed to load",
            duration: 8,
          });
        });
    },
  },
};
</script>

<style lang="css"></style>
